<div class="chart">
    <apx-chart *ngIf="chartOptions" [series]="chartOptions.series" [chart]="chartOptions.chart"
        [dataLabels]="chartOptions.dataLabels" [plotOptions]="chartOptions.plotOptions" [yaxis]="chartOptions.yaxis"
        [xaxis]="chartOptions.xaxis" [fill]="chartOptions.fill" [title]="chartOptions.title"
        [tooltip]="chartOptions.tooltip"></apx-chart>
</div>